import { useCallback, useEffect, useRef, memo, useState } from "react"
import {
  getApartmentMaterial,
  getMaterial
} from "../../../ApartmentFinderConfig/MaterialHelpers"

import { useTexture } from "@react-three/drei"
import {
  hasNumber,
  isIOS,
  returnsAptID,
  returnsBlockIDFromName,
  returnsFloor,
  returnsMaterialType,
  returnsPlotNumber
} from "../Utils/Helpers"
import { useAvailableApartments } from "../Utils/hooks"
import {
  MeshStandardMaterial,
  sRGBEncoding,
  DoubleSide,
  Object3D,
  MeshBasicMaterial,
  MixOperation
} from "three"
import { treesObject } from "../Utils/config/instanceData"
import { useStore } from "../State/Store"
import { masterTexturePath } from "../../../ApartmentFinderConfig/general"
import { blockInfo } from "../../../ApartmentFinderConfig/blockInfo"
import { useFrame } from "@react-three/fiber"

// ** Interactive Mesh Element * //

export const InteractiveMeshElement = memo(
  ({
    name,
    mesh,
    blockID,
    apartmentStatusByPlotNumber,
    apartmentBedsByPlotNumber
  }) => {
    const diffuseTexturePath = `${masterTexturePath}${name.split("-")[1]}_d${
      isIOS ? ".compressed" : ""
    }.jpg`

    const [isDown, setIsdown] = useState()

    const faveRef = useRef()
    const diffuseMap = useTexture(diffuseTexturePath)
    diffuseMap.flipY = false
    diffuseMap.encoding = sRGBEncoding
    const setActiveApt = useStore(useCallback(state => state.setActiveApt, []))
    const setCurrentCameraPositionID = useStore(
      state => state.setCurrentCameraPositionID
    )
    const favourites = useStore(state => state.favourites)
    const setApartmentFinderActive = useStore(
      state => state.setApartmentFinderActive
    )
    const favouritesActive = useStore(state => state.favouritesActive)
    const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
    const activeBlock = useStore(state => state.activeBlock)
    const setActivateBlock = useStore(state => state.setActivateBlock)
    const setActiveFloors = useStore(state => state.setActiveFloors)
    const activeFloor = useStore(state => state.activeFloor)
    const currentCameraPositionID = useStore(
      state => state.currentCameraPositionID
    )

    const handleMouseOver = useCallback(() => {
      document.body.style.cursor = "pointer"
    }, [])
    const handleMouseOut = useCallback(() => {
      document.body.style.cursor = "auto"
    }, [])

    // useEffect(() => {
    //   faveRef.current && console.log(faveRef.current.material)
    // }, [favourites])

    let temp = 0
    let tempo = 0.03
    useFrame(() => {
      if (faveRef.current && favouritesActive) {
        faveRef.current.material.envMapIntensity =
          Math.abs(Math.sin((temp += tempo))) + 0.5
      }
    })

    const storredObjects = {
      ID: useAvailableApartments().map(obj => obj.PlotNumber)
    }

    const floorActive = name => {
      let v =
        returnsFloor(name).includes(activeFloor) &&
        returnsBlockIDFromName(name).includes(activeBlock) &&
        hasNumber(activeBlock)
          ? true
          : false

      return v
    }

    let thisAptAvailable = storredObjects.ID.includes(returnsAptID(name))
      ? true
      : false

    let isInFavourites = favourites.includes(returnsAptID(name)) ? true : false

    const clickedMesh = useCallback(
      (blockID, meshID, floorID) => {
        // console.log(blockID, meshID, floorID)
        // console.log("ACTIVEBLOCK", activeBlock)
        // console.log("ACTIVEFLOOR", activeFloor)
        if (!apartmentFinderActive) {
          setApartmentFinderActive(true)
        } else if (!activeBlock && !blockID.includes(activeBlock)) {
          setActivateBlock(blockID.charAt(0))
          setCurrentCameraPositionID(`block${blockID.charAt(0)}`)
        } else if (!hasNumber(activeBlock) && blockID.includes(activeBlock)) {
          setActivateBlock(blockID)
          blockInfo[blockID].habitableFloors.includes(Number(floorID)) &&
            setActiveFloors(floorID)
          setCurrentCameraPositionID(`building${blockID}`)
        } else if (blockID.includes(activeBlock)) {
          // setCurrentCameraPositionID(`building${blockID}`)
          meshID !== "AA" && setActiveApt(meshID)
        }
      },
      [
        apartmentFinderActive,
        currentCameraPositionID,
        setCurrentCameraPositionID,
        setActivateBlock,
        activeBlock,
        setActiveApt,
        favouritesActive,
        setActiveFloors
      ]
    )

    const clickedFavouriteMesh = useCallback(
      (e, meshID) => {
        console.log(meshID)
        favourites.includes(meshID) && setActiveApt(meshID)
      },
      [
        apartmentFinderActive,
        currentCameraPositionID,
        setCurrentCameraPositionID,
        setActivateBlock,
        activeBlock,
        setActiveApt,
        setActiveFloors
      ]
    )
    return (
      <>
        <mesh
          // {...longPressEvent}
          ref={favourites.includes(returnsAptID(name)) ? faveRef : null}
          onPointerOver={handleMouseOver}
          onPointerOut={handleMouseOut}
          onClick={
            favouritesActive
              ? e => {
                  clickedFavouriteMesh(e, returnsAptID(name))
                }
              : e => {
                  e.stopPropagation()
                  clickedMesh(blockID, returnsAptID(name), returnsFloor(name))
                }
          }
          onPointerDown={e => {
            e.stopPropagation()

            returnsAptID(name) !== "AA" && !favouritesActive && setIsdown(true)
          }}
          onPointerUp={e => {
            e.stopPropagation()
            setTimeout(() => {
              !favouritesActive && setIsdown(false)
            }, 60)
          }}
          material={
            !isDown
              ? returnsPlotNumber(name) !== "AA" || favouritesActive
                ? getApartmentMaterial(
                    favouritesActive,
                    isInFavourites,
                    apartmentFinderActive,
                    // blockActive,
                    apartmentBedsByPlotNumber[returnsPlotNumber(name)],
                    apartmentStatusByPlotNumber[returnsPlotNumber(name)],
                    thisAptAvailable,
                    diffuseMap,
                    isDown
                  )
                : getMaterial(
                    returnsMaterialType(name),
                    floorActive(name),
                    diffuseMap
                  )
              : returnsPlotNumber(name) !== "AA"
              ? new MeshBasicMaterial({ color: "lightblue" })
              : getMaterial(
                  returnsMaterialType(name),
                  floorActive(name),
                  diffuseMap
                )
          }
          geometry={mesh}
        />
      </>
    )
  }
)

// ** Semi-Static Mesh Element * //

export const SemiStaticMeshElement = memo(
  ({ mesh, texturePath, objectID, materialType }) => {
    // const setApartmentFinderActive = useStore(
    //   state => state.setApartmentFinderActive
    // )

    const favouritesActive = useStore(state => state.favouritesActive)
    // const setCurrentCameraPositionID = useStore(
    //   state => state.setCurrentCameraPositionID
    // )

    const handleClick = () => {
      // setCurrentCameraPositionID("site")
      //  !apartmentFinderActive && setApartmentFinderActive(true)
    }

    // returnsMaterialType(name)
    const diffuseMap = useTexture(texturePath)

    diffuseMap.flipY = false
    diffuseMap.encoding = sRGBEncoding

    const FLAT_MAP = new MeshStandardMaterial({
      color: "#fff",
      flatShading: true,

      depthTest: true,
      side: DoubleSide
    })
    const BAKED_MAT = new MeshBasicMaterial({
      combine: MixOperation,
      reflectivity: 1,
      map: diffuseMap,
      depthTest: true,
      polygonOffsetUnits: 0.1,
      side: DoubleSide,
      polygonOffset: true
    })

    return (
      <mesh
        onClick={() => handleClick()}
        material={favouritesActive && objectID === "gf" ? FLAT_MAP : BAKED_MAT}
        geometry={mesh}
      />
    )
  }
)
// ** Static Mesh Element * //

export const StaticMeshElement = memo(
  ({ mesh, texturePath, objectID, materialType }) => {
    const diffuseMap = useTexture(texturePath)

    diffuseMap.flipY = false
    diffuseMap.encoding = sRGBEncoding
    const BAKED_MAT = new MeshBasicMaterial({
      // color:
      //   objectID === "gp"
      //     ? "#000"
      //     : objectID.includes("overlap")
      //     ? "#0f0"
      //     : "#000",
      combine: MixOperation,
      reflectivity: 1,
      map: diffuseMap,
      depthTest: true,
      polygonOffsetUnits: 11,
      side: DoubleSide,
      polygonOffset: true,
      // polygonOffsetFactor: objectID === "gp" ? 1 : 0
      // polygonOffsetFactor:
      //   objectID === "gp" ? 3 : objectID.includes("overlap") ? 1 : 0

      polygonOffsetFactor:
        objectID === "gp" ? 2 : objectID.includes("underlap") ? 1 : 0
    })

    return <mesh material={BAKED_MAT} geometry={mesh} />
  }
)

const tempObject = new Object3D()

// ** Instanced Mesh Element * //

export const InstanceMesh = memo(({ treeType, nodes, TREE_MAT }) => {
  const meshRef = useRef()

  useEffect(() => {
    treesObject[treeType].map((o, id) => {
      tempObject.position.set(o.x, o.z, -o.y)
      tempObject.updateMatrix()
      meshRef.current.setMatrixAt(id, tempObject.matrix)
      return null
    })
  }, [treeType])

  return (
    <instancedMesh
      geometry={nodes[treeType].geometry}
      material={TREE_MAT}
      ref={meshRef}
      args={[null, null, 1000]}
    ></instancedMesh>
  )
})
// export const TestInstanceMesh = memo(({ treeType }) => {
//   const meshRef = useRef()
//   const { nodes } = useGLTF(
//     `${process.env.PUBLIC_URL}/assets/apartmentfinder/instanceGeometry/treetypes.gltf`
//   )

//   const diffuseMap = useTexture(
//     `${process.env.PUBLIC_URL}/assets/apartmentfinder/instanceGeometry/textures/treesTexture.jpg`
//   )

//   diffuseMap.flipY = false

//   const nodesArr = Object.values(nodes)

//   nodesArr.map(n => console.log(n.geometry))
//   // const TREE_MAT = new MeshBasicMaterial({
//   //   flatShading: true,
//   //   map: diffuseMap
//   // })

//   console.log(nodesArr)
//   const TREE_MAT = new MeshBasicMaterial({
//     // color: "blue",
//     // flatShading: true,
//     map: diffuseMap
//   })

//   // useEffect(() => {
//   //   treesObject[treeType].map((o, id) => {
//   //     tempObject.position.set(o.x, o.z, -o.y)
//   //     tempObject.updateMatrix()
//   //     meshRef.current.setMatrixAt(id, tempObject.matrix)
//   //     return null
//   //   })
//   // }, [treeType])

//   return (
//     <>
//       {nodesArr.map(n => (
//         <mesh
//           scale={10}
//           geometry={n.geometry}
//           material={TREE_MAT}
//           // ref={meshRef}
//           position={[103888, 1065, -110004]}

//           // args={[null, null, 1000]}
//         ></mesh>
//       ))}
//     </>
//   )
// })
